import Component from '../inherited/Component'
import axios from 'axios'

export default class RecentlyViewed extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._gridContainer = this._elem.querySelector('[data-recently-viewed-grid-outer')
    this._grid = this._elem.querySelector('[data-recently-viewed-grid')
  }

  async mount () {
    this._elem.parentElement.classList.add('hide')

    let currentHandles = localStorage.getItem('FFC_RECENTLY_VIEWED') ? JSON.parse(localStorage.getItem('FFC_RECENTLY_VIEWED')) : []

    currentHandles.push(this._options.handle)
    currentHandles = [...new Set(currentHandles)]

    localStorage.setItem('FFC_RECENTLY_VIEWED', JSON.stringify(currentHandles))

    let limit = this._options.limit

    for (let handle of currentHandles) {
      if (handle === this._options.handle) continue

      try {
        if (limit === 0) break

        let { data: productResp } = await axios.get(`/products/${handle}?view=ajax-grid-item`)

        let parser = new DOMParser()
        let html = parser.parseFromString(productResp, 'text/html')
        let item = html.querySelector('[data-product-grid-item] > *')

        let li = document.createElement('li')
        li.appendChild(item)

        this._grid.appendChild(li)

        limit--
      } catch (e) {

      }

    }

    if (limit === this._options.limit) {
      this._elem.parentElement.classList.add('hide')
    } else {
      this._elem.parentElement.classList.remove('hide')

      let done = this._options.limit - limit
      
      if (this._options.sliderSettings) {
        let sliderSettings = this._options.sliderSettings

        if (done <= 4) {
          sliderSettings = this._options.sliderSettingsMobile
        }

        this._grid.setAttribute('data-keen-slider', JSON.stringify(sliderSettings))
      }

      this._theme.mountComponents(this._gridContainer)
      this._ctx.emit('ffc--lazy-load-update')
      this._ctx.emit('ffc--quicklink-listen-to', null, this._elem)
    }


  }
}